import type { TourConfig } from '../../model/onboarding.types';

export const IMAGE_GEN_TOUR_ID = 'image_generation';

export const imageGenerationTourConfig: TourConfig = {
  id: IMAGE_GEN_TOUR_ID,
  titleKey: 'onboarding.tours.imageGen.title',
  descriptionKey: 'onboarding.tours.imageGen.listDescription',
  icon: 'Sparkles',
  autoShow: true,
  conditions: {
    requireImages: true,
    excludeBoxed: true,
  },
  // Steps are managed by the state machine inside ImageGenTour component
  steps: [],
};
